import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * AdSenseManager
 * Manages the injection of the Google AdSense script based on the current route.
 * Prevents ads from loading on sensitive or low-content pages (policy compliance).
 */
const AdSenseManager = () => {
    const location = useLocation();

    useEffect(() => {
        // List of paths where Ads should NOT appear
        const excludedPaths = [
            '/onboarding',
            '/login',
            '/signup',
            '/admin',
            '/account',
            '/contact',
            '/privacy', // While allowed, keeping policy pages clean is better
            '/terms',
            '/driver-terms',
            '/advertiser-terms'
        ];

        // Function to check if current path is excluded
        const isExcluded = (path) => {
            return excludedPaths.some(excluded => path.startsWith(excluded));
        };

        // If the page is excluded, do NOT load the script
        if (isExcluded(location.pathname)) {
            return;
        }

        // Check if script is already present
        const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
        if (existingScript) {
            return; // Already loaded
        }

        // Load AdSense Script
        const script = document.createElement('script');
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9189174535642414";
        script.async = true;
        script.crossOrigin = "anonymous";
        document.head.appendChild(script);

        return () => {
            // Optimization: We rarely remove the script in SPAs as it caches,
            // but conceptually we "stop" managing it if we unmount.
        };
    }, [location]);

    return null;
};

export default AdSenseManager;
